<div [id]="backgroundImageId" class="bg-image shadow" color="primary">
  <div class="mask d-flex align-items-center h-100">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-10 col-md-10 col-lg-6 col-xl-5 col-xxl-4">
          <form class="bg-white rounded shadow-5-strong p-4">
            <div class="d-flex justify-content-center" >
              <div class="col-md-8 col-sm-12 d-flex justify-content-center">
                <img [src]="logoUrl" alt="IEA logo" class="logo" />
              </div>
            </div>
            <div class="col-12 text-center">

              <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 186 165" fill="none">
                  <path d="M93 8C51.6454 8 18 41.6454 18 83C18 124.355 51.6454 158 93 158C134.355 158 168 124.355 168 83C168 41.6454 134.355 8 93 8ZM132.032 57.8642L83.5709 115.556C83.0393 116.19 82.3779 116.701 81.6313 117.056C80.8848 117.412 80.0706 117.602 79.244 117.615H79.1466C78.338 117.615 77.5384 117.445 76.7999 117.116C76.0613 116.786 75.4002 116.306 74.8594 115.704L54.0901 92.6274C53.5627 92.068 53.1524 91.4087 52.8833 90.6884C52.6143 89.9681 52.4919 89.2013 52.5235 88.4331C52.555 87.6648 52.7398 86.9106 53.0669 86.2148C53.3941 85.519 53.8571 84.8956 54.4286 84.3813C55.0002 83.8669 55.6688 83.472 56.3951 83.2198C57.1214 82.9675 57.8909 82.863 58.6582 82.9124C59.4255 82.9617 60.1752 83.164 60.8632 83.5072C61.5513 83.8504 62.1637 84.3277 62.6647 84.9111L78.9952 103.055L123.198 50.4435C124.19 49.2972 125.593 48.587 127.104 48.4666C128.614 48.3463 130.112 48.8253 131.273 49.8001C132.433 50.775 133.163 52.1674 133.306 53.6764C133.448 55.1853 132.99 56.6897 132.032 57.8642Z" fill="#7D9B6B" />
                </svg>
              </div>
              <h1 class="fw-bold">Success!</h1>
              <p class="">
                Your IEA online account is now active.<br/>
                Click below to sign in!
              </p>
            </div>
            
            <!-- Submit button -->
            <button type="button" (click)="navigateToLogin()" class="btn btn-primary btn-block w-100 py-2 mt-3">
              SIGN IN
            </button>

            <div class="col-12 text-center mt-3">
              <img class="footer-logo" src="../../../assets/images/poweredby-OneEquineblack-logo.png" alt="IEA logo" />
            </div>

          </form>

        </div>
      </div>
    </div>
  </div>
</div>
